import { Info } from "lucide-react";
import { CalloutBlock } from "@/canvas/components/blocks/CalloutBlock";
import type { BlockConfig } from "../types";

export const calloutBlockConfig: BlockConfig<"callout"> = {
  type: "callout",
  component: CalloutBlock,
  icon: Info,
  iconClassName: "text-indigo-500",
  label: "canvas.blockTypes.callout",
  defaultContent: () => ({
    variant: "info" as const,
    text: "",
  }),
};
